import { ProductGroups } from 'features/onboarding/ProductGroups/ProductGroups';
import { withAuthRouteProtection } from 'hoc/withAuthRouteProtection/withAuthRouteProtection';

const WrappedProductGroups = withAuthRouteProtection(ProductGroups, 'onboarding');
export default WrappedProductGroups;
